import { isNetworkAccountType } from 'modules/account-management';
import {
    FormattedMessageHeaderRenderer,
    withCampaignEditIndication,
} from 'modules/campaigns/modules/campaigns-reports/components';
import { ActivityDetailsValueGetter } from 'modules/campaigns/modules/campaigns-reports/components/ValueFormatters/ActivityDetailsValueGetter';
import createCSVValueGetter from 'modules/campaigns/modules/campaigns-reports/components/ValueFormatters/createCSVValueGetter';
import * as FIELDS from 'modules/campaigns/modules/campaigns-reports/config/fields';
import { normalizeColumnDefs } from 'modules/campaigns/modules/campaigns-reports/utils';
import { PERFORMANCE_RULE_EXECUTED_ACTIONS_REPORT_ID } from './preformanceRuleActionsReportId';

const performanceRuleExecutedActionsReportColumnDefinitions = [
    {
        headerName: FIELDS.PERFORMANCE_RULE_EXECUTED_ACTION_DATE.label,
        field: FIELDS.PERFORMANCE_RULE_EXECUTED_ACTION_DATE.field,
        valueFormatter: FIELDS.PERFORMANCE_RULE_EXECUTED_ACTION_DATE.valueFormatter,
    },
    {
        headerName: FIELDS.PERFORMANCE_RULE_EXECUTED_ACTION_RULE_NAME.label,
        field: FIELDS.PERFORMANCE_RULE_EXECUTED_ACTION_RULE_NAME.field,
        cellRenderer: FIELDS.PERFORMANCE_RULE_EXECUTED_ACTION_RULE_NAME.cellRenderer,
        cellRendererParams: FIELDS.PERFORMANCE_RULE_EXECUTED_ACTION_RULE_NAME.renderParams,
    },
    {
        headerName: FIELDS.PERFORMANCE_RULE_EXECUTED_ACTION_ACCOUNT_NAME.label,
        field: FIELDS.PERFORMANCE_RULE_EXECUTED_ACTION_ACCOUNT_NAME.field,
        cellRenderer: FIELDS.PERFORMANCE_RULE_EXECUTED_ACTION_ACCOUNT_NAME.cellRenderer,
        headerComponentParams: FIELDS.PERFORMANCE_RULE_EXECUTED_ACTION_ACCOUNT_NAME.headerComponentParams,
        visibilityCondition: ({ selectedAccount: { type } }) => isNetworkAccountType(type),
    },
    {
        headerName: FIELDS.PERFORMANCE_RULE_EXECUTED_ACTION_CAMPAIGN_NAME.label,
        headerValueGetter: FormattedMessageHeaderRenderer,
        headerComponentParams: FIELDS.STATUS.headerComponentParams,
        field: FIELDS.PERFORMANCE_RULE_EXECUTED_ACTION_CAMPAIGN_NAME.field,
        cellRenderer: FIELDS.PERFORMANCE_RULE_EXECUTED_ACTION_CAMPAIGN_NAME.cellRenderer,
        cellRendererParams: { isSearchable: true },
    },
    {
        headerName: FIELDS.PERFORMANCE_RULE_EXECUTED_ACTION_ACTIVITY.label,
        field: FIELDS.PERFORMANCE_RULE_EXECUTED_ACTION_ACTIVITY.field,
        cellRenderer: FIELDS.PERFORMANCE_RULE_EXECUTED_ACTION_ACTIVITY.cellRenderer,
        cellRendererParams: { isSearchable: true },
    },
    {
        headerName: FIELDS.PERFORMANCE_RULE_EXECUTED_ACTION_ACTIVITY_DETAILS.label,
        field: FIELDS.PERFORMANCE_RULE_EXECUTED_ACTION_ACTIVITY_DETAILS.field,
        cellRenderer: FIELDS.PERFORMANCE_RULE_EXECUTED_ACTION_ACTIVITY_DETAILS.cellRenderer,
        cellRendererParams: { isSearchable: true },
        csvValueGetter: createCSVValueGetter(ActivityDetailsValueGetter),
    },
];

export default normalizeColumnDefs(
    performanceRuleExecutedActionsReportColumnDefinitions,
    PERFORMANCE_RULE_EXECUTED_ACTIONS_REPORT_ID,
    withCampaignEditIndication
);
